export const DeclarationsListsName = 'declarationsListsComponent';
